import { AxiosPublic } from "../../config/axios";
import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
const initData = { paintings: [], artists: [], categories: [] }

const Search = () => {
    const push = useNavigate()
    const [searchText, setSearchText] = useState("")
    const [data, setData] = useState(initData)
    const [loading, setLoading] = useState(false)
    const searchInput = useRef(null)
    const absolute = useRef(null)

    useEffect(() => {
        window.addEventListener('click', (e) => (!e.target.closest('#absolute')) && setData(null));
        return () => {
            clearTimeout(searchInput.current);
            window.removeEventListener('click', (e) => (!e.target.closest('#absolute')) && setData(null));
        };
    }, []);

    const HandelSearch = async (e) => {
        e.preventDefault()
        if (!searchText.trim()) alert('چیزی برای جستوجو وجود ندارد')
        if (searchText.trim().length < 3) alert('حداقل 3 حرف وارد کنید')
        else {
            setSearchText('')
            const queryParams = new URLSearchParams({ text: searchText, page: 1 }).toString();
            push(`/search?${queryParams}`);
            setLoading(false)
            setData(initData)
        }
    }
    const handleChange = async (e) => {
        const { value } = e.target
        setSearchText(value)
        if (value.trim().length < 3)
            return
        if (value.length) {
            setLoading(true)
            clearTimeout(searchInput.current);
            searchInput.current = setTimeout(async () => {
                await AxiosPublic.get(`q_search?query=${value}`)
                    .then(res => {
                        setData(res.data.data)
                        setLoading(false)
                    })
                    .catch(err => {
                        alert(err.response?.data.message || 'نتیجه ای پیدا نشد')
                        setLoading(false)
                    })
            }, 1000);
        } else setData(initData)
    }

    return (
        <>
            <div className="relative w-full max-w-[500px] self-start">
                <form
                    onSubmit={HandelSearch}
                    className={`bg-white border flex rounded-t-lg ${absolute.current?.children[0] ? '' : 'rounded-b-lg'} overflow-hidden`}>
                    <input
                        dir="auto"
                        className="p-1 flex-1 placeholder:text-right text-right text-black"
                        type="text"
                        placeholder="... جستجو"
                        value={searchText}
                        onChange={handleChange}
                    />
                    <button className="bg-primary border-l px-2 py-1 centerOfParent" aria-label="سرچ">
                        <svg className='text-xl' stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" className="text-xl" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0">
                            </path>
                        </svg>
                    </button>
                </form>
                {(loading || !!data) && <div id="absolute"
                    className="absolute w-full z-10 bg-white text-black overflow-hidden rounded-b-lg" dir="rtl" ref={absolute}>
                    {loading ? <p className="p-3 text-sm">در حال بارگزاری ...</p> :
                        !!(data.paintings.length || data.artists.length || data.categories.length)
                            ? <ul className="flex flex-col">
                                {data.artists.map(r => {
                                    return <div key={r.id} onClick={() => setData(null)}>
                                        <Link to={`/artists/${r.slug}`} className="w-full border-b py-1 px-3 line-clamp-1 cursor-pointer hover:bg-slate-100 duration-200">
                                            <li className="text-sm italic flex items-center gap-2">
                                                <div className="centerOfParent"><svg className="w-4 h-4" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M256 256c52.805 0 96-43.201 96-96s-43.195-96-96-96-96 43.201-96 96 43.195 96 96 96zm0 48c-63.598 0-192 32.402-192 96v48h384v-48c0-63.598-128.402-96-192-96z"></path></svg></div>
                                                <span dir="auto">{r.title} | {r.title_persian}</span>
                                            </li>
                                        </Link>
                                    </div>
                                })}
                                {data.paintings.map(r => {
                                    return <div key={r.id} onClick={() => setData(null)}>
                                        <Link to={`/product/${r.slug}`} className="w-full border-b py-1 px-3 line-clamp-1 cursor-pointer hover:bg-slate-100 duration-200">
                                            <li className="text-sm italic flex items-center gap-2">
                                                <div className="centerOfParent"><svg stroke="currentColor" className="w-4 h-4" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M24 24H0V0h24v24z"></path><path d="M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"></path></svg></div>
                                                <span dir="auto">{r.title} | {r.title_persian}</span>
                                            </li>
                                        </Link>
                                    </div>
                                })}
                                {data.categories.map(r => {
                                    return <div key={r.id} onClick={() => setData(null)}>
                                        <Link to={`/categories/${r.slug}`} className="w-full border-b py-1 px-3 line-clamp-1 cursor-pointer hover:bg-slate-100 duration-200">
                                            <li className="text-sm italic flex items-center gap-2">
                                                <div className="centerOfParent"><svg className="w-4 h-4" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4 2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"></path></svg></div>
                                                <span dir="auto">{r.title}</span>
                                            </li>
                                        </Link>
                                    </div>
                                })}
                                {!!(data.paintings.length || data.artists.length || data.categories.length) &&
                                    <div onClick={HandelSearch} className="w-full border-b py-1 px-3 line-clamp-1 cursor-pointer hover:bg-slate-100 duration-200">
                                        <li className="text-sm italic flex items-center gap-2">
                                            <div className="centerOfParent"><svg className="w-4 h-4 hidden" stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0z"></path><path d="M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4 2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"></path></svg></div>
                                            <span dir="auto">دیدن تمام نتایج</span>
                                        </li>
                                    </div>}
                            </ul>
                            : searchText.length > 0 && <p className="p-3 text-sm">نتیجه ای پیدا نشد</p>
                    }
                </div>}
            </div>
        </>
    );
};

export default Search;